import cookie from 'js-cookie'
import _isNumber from 'lodash/isNumber'
import _isBoolean from 'lodash/isBoolean'
import uuid from 'uuid/v4'

import config from 'src/config'
import BASE_COOKIE_OPTIONS from 'constants/cookieOptions'

const LOCAL_STORAGE = 'localStorage'
const SESSION_STORAGE = 'sessionStorage'
const IN_MEMORY = {}
const STUB_STORAGE = {
  getItem() {},
  setItem() {},
  removeItem() {},
}

function getStorageByType(type) {
  let storage

  try {
    if (type === LOCAL_STORAGE) storage = localStorage
    if (type === SESSION_STORAGE) storage = sessionStorage
  } catch (e) {
    console.log('error accessing storage', e) //eslint-disable-line
  }

  return storage || STUB_STORAGE
}

function setItem(type, key, val) {
  const storage = getStorageByType(type)

  try {
    storage.setItem(key, val)
  } catch (e) {
    console.log('localStorage setItem error', e) //eslint-disable-line
  }
}

function getItem(type, key) {
  const storage = getStorageByType(type)

  let storedVal

  try {
    storedVal = storage.getItem(key)
  } catch (e) {
    console.log('localStorage getItem error', e) //eslint-disable-line
  }

  return storedVal
}

function removeItem(type, key) {
  const storage = getStorageByType(type)

  try {
    storage.removeItem(key)
  } catch (e) {
    console.log('localStorage removeItem error', e) //eslint-disable-line
  }
}

function getSessionToken() {
  const sessionToken = cookie.get(config.SESSION_TOKEN)

  return sessionToken || setSessionToken()
}

function setSessionToken() {
  const sessionToken = uuid()

  cookie.set(
    config.SESSION_TOKEN,
    sessionToken,
    Object.assign(BASE_COOKIE_OPTIONS, {
      expires: undefined, //omitting expires creates a session cookie
    })
  )

  return sessionToken
}

export default {
  /**
   * @param {String} key
   */
  getItem(key) {
    if (!key) throw new Error('key')

    return (
      cookie.get(key) ||
      getItem(LOCAL_STORAGE, key) ||
      getItem(SESSION_STORAGE, key) ||
      IN_MEMORY[key]
    )
  },

  /**
   * @param {String} key
   * @param {String|Object|Array|Number} val
   * @param {Object} [options]
   * @param {Number} [options.expires]
   * @param {Boolean} [options.session]
   */
  setItem(key, val, options) {
    if (!key) throw new Error('key')

    options = options || {}

    if (!_isBoolean(options.cookie)) {
      options.cookie = true
    }

    const cookieOptions = {}

    if (_isNumber(options.expires)) {
      cookieOptions.expires = options.expires
    }

    if (_isBoolean(options.session)) {
      cookieOptions.session = options.session
    }

    cookie.set(key, val, Object.assign(BASE_COOKIE_OPTIONS, cookieOptions))

    setItem(LOCAL_STORAGE, key, val)
  },

  /**
   * @param {String} key
   * @param {String|Object|Array|Number} val
   * @param {Object} [options]
   */
  removeItem(key) {
    if (!key) throw new Error('key')

    cookie.remove(key, BASE_COOKIE_OPTIONS)

    removeItem(LOCAL_STORAGE, key)

    delete IN_MEMORY[key]
  },

  getSessionToken,
  setSessionToken,
}



// WEBPACK FOOTER //
// ./src/lib/storage.js